export default __webpack_public_path__ + "static/media/FractalKukidoBackground.b3bc3028.svg";